<div class="recurring-container">
  <slotcom-p
    [bold]="true"
    [text]="'home.recurring-bag.info.progress' | translate"
    [shadowBorder]="true"></slotcom-p>
  <div
    class="recurring-bag"
    (click)="openProgressLine()">
    <div
      theming
      themingGroup="none"
      themingAsset="recurring-bag-box"
      class="bag-img"
      alt="Bag"></div>
    <slotcom-p
      class="open-casino-label"
      [bold]="true"
      [text]="'home.recurring-bag.info.casino-access' | translate"
      [shadowBorder]="true"></slotcom-p>
    <div
      theming
      themingGroup="none"
      themingAsset="black-arrow"
      class="arrow-img"
      alt="Arrow"></div>
  </div>
  <slotcom-p
    [bold]="true"
    [text]="'home.recurring-bag.info.find-it' | translate"
    [shadowBorder]="true"></slotcom-p>
</div>
